import ajax from '@developers/utils/ajax';
import type { FRPproduct } from '../types/FRPproduct';

export async function getListableProducts(catalog_id: number): Promise<FRPproduct> {
  const response = await ajax({
		url: '/frp/api/products/' + catalog_id,
    data: {
      attributes: 'listable_vendor_products'
    }
  });
    
  return await response.json();
}